import { ViewComponent } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import React from "react";
import Icon, { IconType } from "@edaz/edazkit/Icon";
import formatPostalCode from "@edaz/utils/formatPostalCode";
import TradingPlacesViewModel from "viewModels/tradingPlaces/tradingPlacesViewModel";
import TradingPlaceType from "entities/tradingPlaceType";

const TradingPlaceHeaderView: ViewComponent<TradingPlacesViewModel> = observer(({ vm }) => (
  <>
    {vm.place && (
      <div className="mb-3">
        {vm.place.type === TradingPlaceType.Kiosk && <h5 className="mb-3">{vm.translateGeneral("kiosk")}</h5>}
        <strong className="text-ellipsis d-block mb-1">{vm.place.name}</strong>
        {vm.place.salespoint && (
          <div className="text-ellipsis mb-2">
            {vm.place.salespoint.address}
            {vm.place.salespoint.postalCode ? `, ${formatPostalCode(vm.place.salespoint.postalCode)}` : ""}
          </div>
        )}
        {vm.place.salespoint && (
          <>
            {vm.place.salespoint.cardPaymentAllowed ? (
              <div className="d-flex align-items-center">
                <Icon width={15} height={13} icon={IconType.CardPaymentYes} className="mr-1" />
                <span className="text-success font-weight-bold">{vm.translateGeneral("cardPaymentAllowed")}</span>
              </div>
            ) : (
              <div className="text-danger font-weight-bold">{vm.translateGeneral("cardPaymentNotAllowed")}</div>
            )}
          </>
        )}
      </div>
    )}
  </>
));

export default TradingPlaceHeaderView;
